import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { BlogsActionTypes } from './types'
import { fetchError, fetchSuccess, fetchByNameSuccess, fetchByNameError } from './actions'
import { db } from '../../components/firebase'
import Convert from '../utils/Convert'
import RegExUtils from '../utils/RegExUtils'

// import blogs from '../../data/blog.json'
// import images from '../../data/images.json'
// import galleries from '../../data/imagegallery.json'
// import directories from '../../data/directoriesEvents.json'
// import StringHelper from '../../utils/StringHelper'

function* handleImage(id: number) {
  try {
    let promise = () =>
      db
        .findImage(id)
        .get()
        .then(snapshot =>
          snapshot.docs.map(doc => {
            return doc.data()
          })
        )
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
function saveLogin() {
  login.map((o: any) => {
    db.onceUsers().add(o)
  })
}
function getSingleBlogPromise(id: number) {
  let promise = () =>
    db
      .FindBlog(id)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function FindPreviousBlogPromise(item: any) {
  // console.log('item', item)
  let promise = () =>
    db
      .FindPreviousBlog(item.posted)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function FindNextBlogPromise(item: any) {
  // console.log('item', item)
  item = item == null ? 0 : item

  let promise = () =>
    db
      .FindNextBlog(item.posted)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getBlogByNamePromise(name: string) {
  let promise = () =>
    db
      .FindBlogByName(name)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function getBlogPromise(doc: any, limit: any) {
  doc = doc === undefined ? 0 : doc === null ? null : doc
  limit = limit === undefined ? 25 : limit === null ? 25 : limit
  // console.log('getBlogPromise', doc, limit)
  if (doc == null) {
    let promise = () =>
      db
        .initBlogs(limit)
        .get()
        .then(querySnapshot => querySnapshot.docs)
  } else {
    let promise = () =>
      db
        .onceBlogs(doc, limit)
        .get()
        .then(querySnapshot => querySnapshot.docs)
  }
  return promise()
}

function getImagePromise() {
  let promise = () =>
    db
      .onceImages()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function decorateImage(event: any, images: any) {
  // Consolidate - e.g. add info
  const storageRef = db.storageRef()
  event.map((item: any, index: number) => {
    // update author data if not there
    if (item.data().cover == undefined) {
      // How do we update document with details
      let u: any = images.find((image: any) => image.data().id == item.data().mainimage)
      if (u != undefined) {
        const image = storageRef.child(u.data().location.replace('~', ''))
        console.log(u.data().location.replace('~', ''))

        image.getDownloadURL().then(url => {
          console.log('url', url)
          // update item with author data
          db.GetEventDoc(item.id)
            .update({
              cover: {
                description: u.data().description,
                location: u.data().location,
                id: u.data().id,
                url: url
              }
            })
            .then(function() {
              console.log('Document successfully updated!')
            })
        })
      }
    } else {
      console.log('cover already defined')
    }
  })
}

function* FindStorageURL(storageRef: any, str: string) {
  console.log('FindStorageURL', str)

  let image = storageRef.child(str)
  let promise = () =>
    image.getDownloadURL().then(url => {
      console.log(url)

      return {
        url,
        str
      }
    })
  const result = yield promise()
  return result
}

function* bulkUpdate() {
  console.log('bulkUpdate')
  const blogs = yield call(getBlogPromise, null, 2000)
  console.log('blogs', blogs)

  for (let blog of blogs) {
    // console.log(dlog.data().name)
    const result = yield call(updateURL, blog)
    // const result = yield call(updateBlogByUploadingImagesAndReplaceBody, blog)
    // const resultMakePages = yield call(updateBlogConvertBodyToPage, blog)
    // const result = yield call(updateBlogConvertBodyToPage, blog)
  }
  // const results = yield all(calls)
  // yield put(fetchSuccess(results))
}
function urlTransformer(url) {
  return url
}

function classIdTransformer(name) {
  return name
}

// TODO: Safari throws error if regex uses back lockup
function* updateBlogConvertBodyToPage(blog: any) {
  console.log('updateEventConvertBodyToPage', blog.data().name, blog.data().id)
  //const mediaPattern = /(<(img\s)([\w\W]+?)>)|((<iframe.+src=".+)\/iframe>)|((<iframe.+src="https:\/\/flickrembed.+)>([\w\W]+?)<\/script>)/gim
  //const splitPattern = '||||||' // unique split pattern for devicing array
  //const labelPattern = /<span.*class=.tiptext.*.*?<\/span>/gi
  //const titlePattern = /(?<=<strong>)(.*?)(?=<\/strong>)/gi
  /*const removePatterns = [
    /<font.+?>/gi,
    /<\/font>/gi,
    /<span.+?>/gi,
    /<\/span>/gi,
    /<p?>/gi,
    /<\/p>/gi,
    /<br.\/>/gimu,
    /<br>/gimu,
    /<span>/gi
  ]*/
  let body = blog.data().body
  console.log('before', body)
  RegExUtils.removePatterns.map((pattern, index) => {
    // console.log('pattern ' + pattern, body, body.match(pattern))
    body = body.replace(pattern, '')
  })
  console.log('after', body)
  body = body.replace(/\.<\/strong>/gi, '.</strong> ')
  body = body.replace(/\.<\/b>/gi, '.</b> ')

 // const tablePattern = /<table.+>([\s\S]*?)<\/table>/gim
  //const noEmptyPattern = /<td+>\w+<\/td>/gim

  let mediaMatch = body.match(RegExUtils.mediaPattern)
  let titleMatch = body.match(RegExUtils.labelPattern)
  let mediaArr = []
  //match up all media

  // let parser = new DOMParser()
  // var doc = parser.parseFromString(blog.data().body, 'text/html')
  // console.log('mediaMatch', doc.body, doc.getElementsByName('iframe'), mediaMatch)
  console.log('mediaMatch', mediaMatch)
  if (mediaMatch != null) {
    for (let i = 0; i < mediaMatch.length; i++) {
      // add a split patterns into the body
      body = body.replace(mediaMatch[i], RegExUtils.splitPattern)
      let media = mediaMatch[i]
      let src =
        media.match(RegExUtils.imagePattern) != null
          ? media.match(RegExUtils.imagePattern)[0]
          : ''
      let alt =
        media.match(RegExUtils.altPattern) != null
          ? media.match(RegExUtils.altPattern)[0]
          : ''
      console.log('src', src)
      let mediaType = 'image'
      if (src.indexOf('youtube') != -1) {
        mediaType = 'youtube'
      } else if (src.indexOf('vimeo') != -1) {
        mediaType = 'vimeo'
      } else if (src.indexOf('flickr') != -1) {
        mediaType = 'flickr'
      }
      let mediaObj = {
        type: mediaType,
        url: mediaType == 'flickr' ? src.match(RegExUtils.flickrPattern)[0] : src,
        label: mediaType == 'image' ? alt : titleMatch != null ? titleMatch[i] : ''
      }
      mediaArr.push(mediaObj)
    }
  }
  console.log('mediaArr', mediaArr)
  //split the body into pages
  let pageArrX = body.split(RegExUtils.splitPattern)
  let pageArr = []
  //clear out empty parts
  for (let i = 0; i < pageArrX.length; i++) {
    let p = RegExUtils.Sanitize(pageArrX[i]);
    let trimmed = p.replace(/<.*?>/gi, '').trim()
    let parser = new DOMParser()
    var doc = parser.parseFromString(trimmed, 'text/html')
    if (doc.body.innerText.trim() == '') {
      trimmed = ''
    }
    if (trimmed != '') {
      pageArr.push(p)
    } else {
      pageArr.push('')
    }
  }

  var pages = []
  console.log('pageArr', pageArr)
  for (let i = 0; i < pageArr.length; i++) {
    let pageBody = pageArr[i]
    pageBody = RegExUtils.Sanitize(pageBody.replace(RegExUtils.labelPattern, ''));
    // console.log('page', pageBody)

    const table = pageBody.match(RegExUtils.tablePattern)
    // console.log(table)
    if (table != null) {
      console.log(table[0].match(RegExUtils.noEmptyPattern))
      let parser = new DOMParser()
      var doc = parser.parseFromString(table[0], 'text/html')
      if (doc.body.innerText.trim() == '') {
        pageBody = pageBody.replace(RegExUtils.tablePattern, '')
      }
    }
    let title = ''
    if (pageBody.match(RegExUtils.titlePattern) != null) {
      title = pageBody.match(RegExUtils.titlePattern).length != -1 ? pageBody.match(RegExUtils.titlePattern)[0] : ''
    }
    title = title.replace(/<br>/gi, '')
    let obj = {
      theme: i % 2 == 0 ? 'light' : 'dark',
      title: title,
      subtitle: '',
      body: pageBody
    }
    console.log('mediaArr[' + i + ']', mediaArr[i])
    if (mediaArr[i] != undefined) {
      obj['media'] = mediaArr[i]
    }
    // console.log(obj['media'] == '', obj['body'] == '')
    let mediatype = ''
    if (obj['media'] != undefined) mediatype = obj['media']['type']
    if (obj['body'] == '' && pages.length > 0 && mediatype == 'image') {
      if (obj['media'] != undefined) {
        let curpage = pages[pages.length - 1]
        let curmed = curpage['media']

        if (!Array.isArray(curmed)) {
          curmed = [curmed]
        }
        curmed.push(obj['media'])
        console.log('====', curpage, curmed, obj['media'])
        curpage['media'] = curmed
      }
    } else {
      if (obj['body'] == '' && obj['media'] == undefined) {
      } else {
        pages.push(obj)
      }
    }
  }
  // Check page consistency
  // console.log("P{AGES", pages);
  let pagesConsitent = []
  for (let i = 0; i < pages.length; i++) {
    if (i + 1 < pages.length) {
      // console.log((pages[i+1]['body']!="") +"&&"+ (pages[i+1]['media']===undefined) +"&&"+ (pages[i]["media"]!=undefined) +"&&"+ (pages[i]["body"]==""))
      if (
        pages[i + 1]['body'] != '' &&
        pages[i + 1]['media'] === undefined &&
        pages[i]['media'] != undefined &&
        pages[i]['body'] === ''
      ) {
        pages[i]['body'] = pages[i + 1]['body']
        pages[i + 1]['body'] = ''
      }
    }
    if (pages[i]['body'] != '' || pages[i]['media'] != undefined) {
      pagesConsitent.push(pages[i])
    }
  }

  pages = pagesConsitent
  if (pages.length == 0) {
    console.log('no pages to create')
  } else {
    console.log(
      'PAGES Consitent',
      pages[0].hasOwnProperty('media')
        ? Array.isArray(pages[0].media)
          ? pages[0].media[0]
          : pages[0].media
        : undefined
    )
    let updateObj = { pages: pages }
    if (pages[0].hasOwnProperty('media')) {
      updateObj['cover'] = Array.isArray(pages[0].media) ? pages[0].media[0] : pages[0].media
    }
    db.GetBlogDoc(blog.id)
      .update(updateObj)
      .then(function() {
        console.log('Document ' + blog.data().name + ' successfully updated!', blog.data().id)
      })
    console.log(pages)
  }
  return pages
}
function* updateBlogBody(blog: any) {
  let body = blog.data().body
  body = Convert(body)
  // console.log('body', body)
  const result = db
    .GetBlogDoc(blog.id)
    .update({
      body: body
    })
    .then(function() {
      console.log('Document ' + blog.id + ' successfully updated!')
    })
  return result
}
function* updateURL(blog: any) {
  let name = blog.data().name
  // console.log(name)
  name = StringHelper(name)
  // console.log(name)
  db.GetBlogDoc(blog.id)
    .update({
      url_name: name
    })
    .then(function() {
      console.log(
        'updateURL ',
        blog.data().name,
        blog.data().url_name,
        name,
        ' successfully updated!'
      )
    })
}

function* updateBlogByUploadingImagesAndReplaceBody(blog: any) {
  console.log('============= image replacing ======================')
  console.log('updateBlogByUploadingImagesAndReplaceBody', blog.data())
  const regex = /(userdata\/)([\/|.|\w|\s|-])*\.(?:jpg|gif|png)/gi
  const storageRef = db.storageRef()
  const replaceLower = directories
  let imagesToReplace = []
  let images = []
  let data = blog.data()
  let body = data.body
  if (data.hasOwnProperty('body_old')) {
    body = data.body_old
  }
  body = body.replace(/file:\/\/\/E:\/inetpub\/wwwroot\/c-lab\//gim, '')
  if (body.match(regex) != null) {
    let str = ''

    body
      .match(regex)

      .map(m => {
        console.log('match', m)
        str = m

        replaceLower.map(folder => {
          str = str.replace('/' + folder + '/', '/' + folder.toLowerCase() + '/')
        })
        if (str.indexOf('/sonicimpairment/') != -1) {
          str = str.replace('/sonicimpairment/', '/events/sonicimpairment/')
        }
        str = flatFile(str)
        console.log('flat', str)

        imagesToReplace.push({ updated: str, original: m })
        // calls.push(call(FindStorageURL(storageRef, str)()))
      })

    console.log('imagesToReplace', imagesToReplace)
    let imageStorage = []
    for (let img of imagesToReplace) {
      const result = yield call(FindStorageURL, storageRef, img.updated)
      console.log('result', result)
      result.original = img.original
      imageStorage.push(result)
    }

    console.log(storageRef, str, result)
    // let body = blog.data().body

    for (let i of imageStorage) {
      body = body.replace(i.original, i.url)
      console.log(i.original + ' ' + i.url)
    }
    images.push({ images: imageStorage, blog: blog, body: body })
  }

  images.map(item => {
    console.log(item.blog.id)

    db.GetBlogDoc(item.blog.id)
      .update({
        body_old:
          item.blog.data().body_old == null ? item.blog.data().body : item.blog.data().body_old,
        body: item.body
      })
      .then(function() {
        console.log('Document ' + item.blog.data().name + ' successfully updated!', item.body)
      })
  })
}

function flatFile(str: string) {
  let dirs = str.split('/')
  let normaldirs: any = []
  let flatdirs: any = []
  let flattened = ['cache', 'blogs', 'articles']
  let found = false
  let filename = ''
  dirs.map((dir: any, index: number) => {
    if (dir != '') {
      if (found) {
        flatdirs.push(dir)
      } else {
        normaldirs.push(dir)
      }
    }
    for (var i = 0; i < flattened.length; i++) {
      if (dir.toLowerCase() == flattened[i]) {
        found = true
      }
    }
  })
  if (found) {
    console.log(flatdirs.join('-').toLowerCase())
    normaldirs.push(flatdirs.join('-'))
    return normaldirs.join('/').toLowerCase()
  } else {
    return str
  }
}
function getUsersPromise() {
  let promise = () =>
    db
      .onceUsers()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function* handleFetchByName(data: any) {
  // console.log('handleFetchByName', data)
  const res = yield getBlogByNamePromise(data.payload)
  // console.log('handleFetchByName result', res)

  let out = res.map(item => item.data())

  if (out[0] != undefined) {
    if (out[0].hasOwnProperty('url_name')) {
      const nextBlog = yield FindNextBlogPromise(out[0])
      const previousBlog = yield FindPreviousBlogPromise(out[0])

      // console.log('nextBlog', nextBlog[0].data().url_name)
      // console.log('previousBlog', previousBlog[0].data().url_name)
      if (nextBlog[0] != null) out[0].next = nextBlog[0].data()
      if (previousBlog[0] != null) out[0].previous = previousBlog[0].data()
    }

    yield put(fetchByNameSuccess(out[0]))
  } else {
    yield put(fetchByNameError('no data found'))
  }
}
function* authorFix(res: array) {
  const resUser = yield getUsersPromise()
  // const resImages = yield getImagePromise()
  res.map((item: any, index: number) => {
    if (item.data().author == undefined) {
      // How do we update document with author details
      let u: any = resUser.find((user: any) => user.data().id == item.data().authorid)
      if (u != undefined) {
        // update item with author data
        console.log(u.data())
        db.GetBlogDoc(item.id)
          .update({
            author: {
              name: u.data().name,
              email: u.data().email,
              profile: u.data().profile
            }
          })
          .then(function() {
            console.log('Document successfully updated!')
          })
      }
    } else {
      console.log('author already defined')
    }
  })
  console.log(res)
  console.log(resUser)
}
function* handleFetch(data: any) {
  // saveLogin()
  try {
    let doc = data.payload
    if (doc != null) {
      doc = doc[doc.length - 1]
      doc = doc.posted
    }

    const res = yield getBlogPromise(doc)
    let out: any = res.map(item => item.data())

    // authorFix
    // for (let blog of res) {
    //   const result = yield call(updateURL, blog)
    // }

    if (data.payload != null) {
      // console.log('out', out)
      // console.log('doc', data.payload)
      out = data.payload.concat(out)
    }
    // console.log('out', out)
    yield put(fetchSuccess(out))
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* update(data) {
  console.log('update', data.payload)
  const blogs = yield call(getSingleBlogPromise, data.payload)
  for (let blog of blogs) {
    console.log(blog, blog.exists)
    if (blog.exists) {
      const result = yield call(updateURL, blog)
      // const resultUpdateImage = yield call(updateBlogByUploadingImagesAndReplaceBody, blog)
      const resultUpdateBody = yield call(updateBlogBody, blog)

      const resultMakePages = yield call(updateBlogConvertBodyToPage, blog)
      // const results = yield all(calls)
      // yield put(fetchSuccess(resultMakePages))
    }
  }
}

function* watchBulkRequest() {
  // console.log('watchBulkRequest ', arguments)
  yield takeEvery(BlogsActionTypes.BULK_UPDATE, bulkUpdate)
}
function* watchUpdateRequest() {
  // console.log('watchUpdateRequest ', arguments)
  yield takeEvery(BlogsActionTypes.UPDATE, update)
}
// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  yield takeEvery(BlogsActionTypes.FETCH_REQUEST, handleFetch)
}

function* watchFetchByNameRequest() {
  yield takeEvery(BlogsActionTypes.FETCH_BY_NAME_REQUEST, handleFetchByName)
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* BlogsSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchFetchByNameRequest),
    fork(watchBulkRequest),
    fork(watchUpdateRequest)
  ])
}

export default BlogsSaga
